import * as React from "react";
import PopDetail from "../../popdetail";
import GeneralSelect from "../../general_select";
import Wait from "../../wait";
import ReadService from "../../../service/read";

export default class ReportFilterPane extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            regionOptions: {},
            districtOptions: {},
            villageOptions: {},
            is_village: 'none',
        }

        this.loadData = this.loadData.bind(this)
        this.handleChanges = this.handleChanges.bind(this)
        this.handleChangeFile = this.handleChangeFile.bind(this)
    }


    componentDidMount() {
        this.loadData()
    }

    handleChanges = (e) => {
        this.setState({[e.target.name]: e.target.value})
    }
    handleChangeFile = e => {
        this.setState({zipped: e.target.files[0]})
    }


    render() {
        return (<div className={'row'}>

            <div className={'col col-sm-12'} style={{padding: 0}}>

                <table style={{width: '40%', margin: '2%'}}>
                    <tbody>
                    <tr>
                            <td colSpan={3}>
                                <GeneralSelect onChanges={(e) => this.generalSelect(e, 'region')}
                                               parameters={this.state.regionOptions}/>
                            </td>
                    </tr>
                    <tr style={{display: this.state.is_village}}>
                            <td colSpan={3}>
                                <GeneralSelect onChanges={(e) => this.generalSelect(e, 'region')}
                                               parameters={this.state.regionOptions}/>
                            </td>
                    </tr>
                    </tbody>
                </table>

                <div style={{textAlign: 'center', width: '100%', float: 'left'}}>
                    <button className={'btn submit'} onClick={this.submit}>
                        <span className={'fa fa-save'}/>Submit
                    </button>
                    <button className={'btn error'} onClick={() => PopDetail.dismiss()}>
                        <span className={'fa fa-times'} style={{padding: 0}}/>Close
                    </button>
                </div>

            </div>

        </div>)
    }

    loadData() {
        if (this.props.report.filter.split(',').includes('village')){
            this.setState({
                regionOptions: {
                    endpoint: `localities/list?level_id=` + sessionStorage.getItem('regional_level_id'),
                    value: 'id',
                    label: 'name',
                    placeholder: 'Select Region'
                },
                is_village: 'table-row'
            })
        }

    }
}